<span class="chip">
  <span>
    {{chipText}}
  </span>
  <i (click)="removeChip()" class="fa fa-close"></i>
</span>
